<div class="container">
    <div class="row mt-5">
        <div class="col-md-12">
            <div class="text-center">
                <h1>Lista Utenti</h1>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-12 d-flex justify-content-end">
            <button class="btn btn-primary" (click)="aggiungiUtente()">Aggiungi Utente</button>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-md-12 text-center">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Cognome</th>
                        <th>Email</th>
                        <th>Stato</th>
                        <th>Abilitato</th>
                        <td>Modifica</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let utente of utenti">
                        <td>{{utente.getNome()}}</td>
                        <td>{{utente.getCognome()}}</td>
                        <td>{{utente.getEmail()}}</td>
                        <td>{{utente.getTipoUt()}}</td>
                        <td>{{utente.getConfirmed()==true ? 'OK' : ''}}</td>
                        <td>
                            
                            
                            <button class="btn btn-primary" (click)="password(utente.getID())">
                                <i class="fas fa-asterisk"></i>
                            </button>
                            <button class="btn btn-primary" (click)="modificaUtente(utente.getID())">
                                <i class="fas fa-address-card"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>